import { createSlice } from "@reduxjs/toolkit";
import Swal from "sweetalert2";
import { USER_LOGOUT } from "../SagaAction/actions";

export const UserSlice = createSlice({
  name: "product",
  initialState: {
    UserData: [],
    loading: false,
    UserUpdated: [],
    GuestUserData:[],
    viewProfileData: null
  },
  reducers: {
    userViewProfileDetailsRequest(state,action){
      return {...state,loading: true}
    },
    userViewProfileDetailsSuccess(state,action){
      return {...state,viewProfileData : action.payload, loading:false }
    },
    userViewProfileDetailsFailure(state,action){
      return {...state, loading:false}
    },
    updatedUserPersonalDetailsRequest(state) {
      return { ...state, loading: true };
    },
    updatedUserPersonalDetailsSuccess(state, action) {
      Swal.fire({
        position: "center",
        icon: "success",
        text: action.payload.meta.message,
      });
      return {
        ...state,
        UserUpdated: action.payload,
        loading: false,
      };
    },
    updatedUserPersonalDetailsFailure(state) {
      return {
        ...state,
        loading: false,
      };
    },
  },
  extraReducers: (builder) => {
    builder.addCase(USER_LOGOUT, (state, action) => {
      localStorage.removeItem("authToken");
      localStorage.removeItem("email");
      localStorage.removeItem("isLogin");
      return {
        UserData: [],
        loading: false,
        UserUpdated: [],
        GuestUserData:[],
        viewProfileData: null
      };
    });
  },
});
export const {
  updatedUserPersonalDetailsRequest,
  updatedUserPersonalDetailsSuccess,
  updatedUserPersonalDetailsFailure,
  userViewProfileDetailsFailure,
  userViewProfileDetailsRequest,
  userViewProfileDetailsSuccess
} = UserSlice.actions;
export default UserSlice.reducer;
